import { render, staticRenderFns } from "./Abas.vue?vue&type=template&id=a32e5a2e"
import script from "./Abas.vue?vue&type=script&lang=js"
export * from "./Abas.vue?vue&type=script&lang=js"
import style0 from "./Abas.vue?vue&type=style&index=0&id=a32e5a2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports